import React from "react";
import { Box, IconButton, Icon } from "@mui/material";
import PeaceIcon from "@mui/icons-material/EmojiEmotions";
import BrushIcon from "@mui/icons-material/Brush";
import BookIcon from "@mui/icons-material/MenuBook";
import AlignIcon from "@mui/icons-material/FormatAlignCenter";
import EditIcon from "@mui/icons-material/Edit";
import { useTheme } from "@mui/material/styles";
const PillButtonGroup = ({ options, dark }) => {
  const theme = useTheme();
  return (
    <Box
      {...(options?.length > 1
        ? {}
        : {
            onClick: options?.length ? options[0]?.item?.onClick : () => {},
          })}
      sx={{
        position: "relative",
        width: "fit-content",
        "@keyframes glowPulse": {
          "0%": { opacity: 0.7, boxShadow: "0 0 10px rgba(138, 43, 226, 0.5)" },
          "50%": { opacity: 1, boxShadow: "0 0 20px rgba(138, 43, 226, 0.8)" },
          "100%": {
            opacity: 0.7,
            boxShadow: "0 0 10px rgba(138, 43, 226, 0.5)",
          },
        },
        "&::before": {
          content: '""',
          position: "absolute",
          top: -2,
          left: -2,
          right: -2,
          bottom: -2,
          borderRadius: "32px",
          background: "linear-gradient(45deg, #8a2be2, #da70d6)",
          boxShadow: "0 0 15px rgba(138, 43, 226, 0.7)",
          animation: "glowPulse 3s infinite ease-in-out",
          zIndex: 0,
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "60px",
          backgroundColor: dark
            ? theme.palette.primary.dark
            : theme.palette.primary.main,
          borderRadius: "30px",
          boxShadow: 3,
          padding: "10px",
        }}
      >
        {options.map((item, index) => {
          return (
            <IconButton
              onClick={item.onClick}
              sx={{
                color: "#fff",
                "&:hover": {
                  color: "#ce35ff",
                },
              }}
              key={index}
              color="primary"
            >
              <Icon
                sx={{
                  color: "#fff",
                  "&:hover": {
                    color: "#ce35ff",
                  },
                }}
              >
                {item.icon}
              </Icon>
            </IconButton>
          );
        })}
      </Box>
    </Box>
  );
};

export default PillButtonGroup;
